module.exports = __webpack_public_path__ + "static/media/plus.8ff9897f.svg";